<template>
	<div class="topic_sum">
		<div class="container-fluid">
			<!-- Begin page -->
			<div class="wrapper">
				<div class="content-page">
					<div class="content">
						<div class="row">
							<div class="col-12">
								<div class="page-title-box">
									<div class="page-title-right"><Breadcrumb /></div>
									<div style="display:flex;">
										<h3 class="header-title mb-3">待评审作品</h3>
										<el-button type="info" style="width:max-content;height: 30px;margin: 5px 0 0 20px;" size="small" @click="goBack">返回</el-button>
									</div>
								</div>
								<!-- end page-title-box -->
							</div>
							<!-- end col-->
						</div>
						<div class="row">
							<div class="col-12">
								<div class="card">
									<div class="card-body">
										<div>
											说明：本次评审
											<!-- <span style="color: red;">{{ startTime }}</span>
											开始， -->
											<span style="color: red;">{{ endTime }}</span>
											结束
										</div>
										<div class="body-nav">
											<div>
												<span>名称：</span>
												<el-input size="small" style="width: 200px;" placeholder="请输入课程名称" v-model="title" clearable></el-input>
												<el-button size="small" type="success" style="margin-left: 20px;" @click="getTable">查询</el-button>
											</div>
											<div>
												<el-button type="primary" icon="el-icon-upload2" size="small" @click="submitBtn" v-if="showSubmit">提交我的评审</el-button>
												<el-button type="primary" icon="el-icon-upload" size="small" @click="exportExcel">导出Excel</el-button>
											</div>
										</div>
										<el-table id="table" :header-cell-style="tableStyle" border :data="topicSumData" style="width: 100%;margin-bottom: 20px;">
											<el-table-column type="index" label="序号" width="50"></el-table-column>
											<el-table-column prop="title" label="名称" width="400">
												<template slot-scope="scope">
													<div style="cursor: pointer;color: #409eff;text-align: left;" @click="goRoute(scope.row)">{{ scope.row.title }}</div>
												</template>
											</el-table-column>
											<el-table-column prop="learningSectionString" label="学段"></el-table-column>
											<el-table-column prop="disciplineIdString" label="学科"></el-table-column>
											<el-table-column prop="score" label="评分">
												<template slot-scope="scope">
													{{ scope.row.score == 0 ? '' : scope.row.score }}
												</template>
											</el-table-column>
											<el-table-column prop="note" label="评语" width="250"></el-table-column>
											<el-table-column label="操作" width="170">
												<template slot-scope="scope">
													<el-button
														size="small"
														v-if="
															scope.row.eduProjectManagementExpertsScore == null ||
																(scope.row.eduProjectManagementExpertsScore !== null &&
																	scope.row.eduProjectManagementExpertsScore.isSubmit == 0 &&
																	scope.row.score == 0)
														"
														type="primary"
														@click="goRoute(scope.row)"
													>
														评分
													</el-button>
													<el-button
														size="small"
														v-if="
															(scope.row.eduProjectManagementExpertsScore !== null &&
																scope.row.eduProjectManagementExpertsScore.score !== 0 &&
																scope.row.eduProjectManagementExpertsScore.isSubmit == 0) ||
																(scope.row.eduProjectManagementExpertsScore !== null &&
																	scope.row.eduProjectManagementExpertsScore.isSubmit == 1 &&
																	scope.row.score == 0)
														"
														@click="goRoute(scope.row)"
													>
														修改评分
													</el-button>
												</template>
											</el-table-column>
										</el-table>
										<div class="pagination">
											<el-pagination
												@size-change="handleSizeChange"
												@current-change="handleCurrentChange"
												:current-page="pageNumber"
												:page-sizes="[50, 100, 200]"
												:page-size="pageSize"
												layout="total, sizes, prev, pager, next, jumper"
												:total="underStudyTopicTotal"
											></el-pagination>
										</div>
									</div>
									<!-- end card-body-->
								</div>
								<!-- end card -->
							</div>
							<!-- end col-->
						</div>
					</div>
				</div>
			</div>
			<!-- end wrapper-->
		</div>
	</div>
</template>

<script>
import { getPageListReview, saveOrUpdateExpertsScoreUp, getReviewInfo, ExpertsScoreUp, saveOrUpdateExpertsScoreUp2 } from '@/api/after/newInterface';
import Breadcrumb from '@/views/backstage/components/Breadcrumb.vue';
import XLSX from 'xlsx';
import FileSaver from 'file-saver';
export default {
	components: {
		Breadcrumb
	},
	data() {
		return {
			tableStyle: {
				backgroundColor: '#7e9be2',
				color: '#fff',
				textAlign: 'center'
			},
			topicSumData: [],
			underStudyTopicTotal: 10,
			pageNumber: 1,
			pageSize: 20,
			title: '',
			startTime: null,
			endTime: null,
			subState: null,
			showSubmit: true
		};
	},
	created() {
		this.getTable();
		this.getCurrentInfo();
		this.subState = this.$route.query.state;
		this.saveOrUpdateExpertsScoreUp2();
	},
	methods: {
		saveOrUpdateExpertsScoreUp2() {
			saveOrUpdateExpertsScoreUp2(this.$route.query.id).then(res => {
				this.showSubmit = res.data;
			});
		},
		goBack() {
			this.$router.push('/backstage/expertRatingCollective')
		},
		// 提交我的审核
		submitBtn() {
			ExpertsScoreUp(this.$route.query.id).then(res => {
				if (res.code == 200) {
					if (res.data) {
						this.$confirm('提交我的评审后，不能再修改评分和评语，确定要提交吗？', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							saveOrUpdateExpertsScoreUp(this.$route.query.id).then(res => {
								if (res.code == 200) {
									this.$message.success(res.msg);
									this.getTable();
									this.saveOrUpdateExpertsScoreUp2()
								} else {
									this.$message.error(res.data);
								}
							});
						});
					} else {
						this.$message.error(res.msg);
					}
				} else {
					this.$message.error(res.data);
				}
			});
		},
		// 导出excel
		exportExcel() {
			let exportFileName = '待评审作品.xlsx';
			var xlsxParam = { raw: true };
			var wb = XLSX.utils.table_to_book(document.querySelector('#table'), xlsxParam);
			var wbout = XLSX.write(wb, {
				bookType: 'xlsx',
				bookSST: true,
				type: 'array'
			});
			try {
				FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), exportFileName);
			} catch (e) {
				if (typeof console !== 'undefined') {
					console.log(e, wbout);
				}
			}
			return wbout;
		},
		handleSizeChange(val) {
			this.pageSize = val;
			this.getTable();
		},
		handleCurrentChange(val) {
			this.pageNumber = val;
			this.getTable();
		},
		//当前信息
		getCurrentInfo() {
			getReviewInfo(this.$route.query.id).then(res => {
				if (res.code == 200) {
					if (res.data.eduExpertsSubjectGroup) {
						this.startTime = res.data.eduExpertsSubjectGroup.createTime;
						this.endTime = res.data.eduExpertsSubjectGroup.reviewEndTime;
					}
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		getTable() {
			let params = {
				pageNumber: this.pageNumber,
				pageSize: this.pageSize,
				projectId: this.$route.query.id,
				title: this.title,
				whether: true
			};
			getPageListReview(params).then(res => {
				if (res.code == 200) {
					this.topicSumData = res.data.records;
					this.underStudyTopicTotal = res.data.total;
				} else {
					this.$message.error(res.data);
				}
			});
		},
		goRoute(row) {
			this.$router.push({ path: `/backstage/IndividualRatingCollective?id=${row.id}&projectId=${this.$route.query.id}&state=${this.subState}` });
		}
	}
};
</script>

<style scoped lang="scss">
::v-deep .el-date-editor.el-input {
	width: 100%;
}
.btn_wrap {
	margin-bottom: 20px;
	display: flex;
	align-items: center;
	// justify-content: space-between;
}
.pagination {
	display: flex;
	justify-content: center;
}
.body-nav {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin: 20px 0;
}
</style>
